import { post } from '../index'
import utils from '@assets/utils'                    // 公共自定义钩子函数
import $store from '../../../store'

const cache = utils.cache
// console.log(cache)
/** 这个函数用来调用接口得到参数用的
 * @method getData
 * @param {这是一个字符串常量，决定调用哪一个接口} str 
 * @param {这是请求参数} obj
 */
const getData = (str, obj) => {
  return new Promise((resolve, reject) => {
    // 传参字符串
    let objStr = JSON.stringify(obj)
    let cacheObj = cache(`api:${str}:${objStr}`) ? JSON.parse(cache(`api:${str}:${objStr}`)) : null
    // 参数是否一样
    // let bol = (cacheObj && (cacheObj.objStr === objStr))
    // 如果有缓存走这一步 两个小时的缓存
    if (cacheObj && (($store.state.common.nowDate - cacheObj.nowDate) < 7200000)) {
      resolve(cacheObj)
    } else {
      post(str, obj).then(({ data }) => {
        // 多久放进去的
        data.nowDate = $store.state.common.nowDate
        // 放入缓存
        cache(`api:${str}:${objStr}`, JSON.stringify(data))
        resolve(data)
      }).catch(err => {
        reject(err)
      })
    }
  })
}

// 获取赛事列表 str
export default async (str, obj) => {
  try {
    let data = await getData(str, obj)
    return data
  } catch (err) {
    console.log(err)
  }
}



// WEBPACK FOOTER //
// ./src/assets/api/js/common.js